import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addJob, updateJob } from "../../features/Job/jobSlice";

const initialState = {
  title: "",
  type: "",
  salary: "",
  deadline: "",
};

export default function Form() {
  const editjob = useSelector((state) => state.Jobs.editJob);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initialState);
  const newJob = {
    title: formData.title,
    type: formData.type,
    salary: formData.salary,
    deadline: formData.deadline,
  };

  useEffect(() => {
    if (editjob) {
      const { title, type, salary, deadline } = editjob;
      setFormData({
        title,
        type,
        salary,
        deadline,
      });
    }
  }, [editjob]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (editjob) {
      newJob.id = editjob.id;
      dispatch(updateJob(newJob));
      navigate("/");
    } else {
      dispatch(addJob(newJob));
    }

    setFormData(initialState);
  };

  return (
    <>
      <h1 className="mb-10 text-center lws-section-title">
        {editjob ? "Edit Job" : "Add New Job"}
      </h1>
      <div className="max-w-3xl mx-auto">
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="fieldContainer">
            <label
              htmlFor="lws-JobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select
              id="lws-JobTitle"
              name="lwsJobTitle"
              value={formData.title}
              required
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
            >
              <option value hidden selected>
                Select Job
              </option>
              <option>Software Engineer</option>
              <option>Software Developer</option>
              <option>Full Stack Developer</option>
              <option>MERN Stack Developer</option>
              <option>DevOps Engineer</option>
              <option>QA Engineer</option>
              <option>Product Manager</option>
              <option>Social Media Manager</option>
              <option>Senior Executive</option>
              <option>Junior Executive</option>
              <option>Android App Developer</option>
              <option>IOS App Developer</option>
              <option>Frontend Developer</option>
              <option>Frontend Engineer</option>
            </select>
          </div>
          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select
              id="lws-JobType"
              name="lwsJobType"
              value={formData.type}
              required
              onChange={(e) =>
                setFormData({ ...formData, type: e.target.value })
              }
            >
              <option value hidden selected>
                Select Job Type
              </option>
              <option>Full Time</option>
              <option>Internship</option>
              <option>Remote</option>
            </select>
          </div>
          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                type="number"
                name="lwsJobSalary"
                id="lws-JobSalary"
                value={formData.salary}
                required
                onChange={(e) =>
                  setFormData({ ...formData, salary: e.target.value })
                }
                className="!rounded-l-none !border-0"
                placeholder="20,00,000"
              />
            </div>
          </div>
          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input
              type="date"
              name="lwsJobDeadline"
              id="lws-JobDeadline"
              value={formData.deadline}
              onChange={(e) =>
                setFormData({ ...formData, deadline: e.target.value })
              }
              required
            />
          </div>
          <div className="text-right">
            <button
              type="submit"
              id="lws-submit"
              className="cursor-pointer btn btn-primary w-fit"
            >
              {editjob ? "Edit" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
